import '@/components/LocalizedStringLoader'
import Quiz from '@/components/quiz/Quiz'
import checkIcon from '@/icons/check-icon.svg'
import easilyDissolvesIcon from '@/icons/easily-dissolves-icon.webp'
import nextArrowIcon from '@/icons/next-arrow-icon.svg'
import noHarshChemicalsIcon from '@/icons/no-harsh-chemicals-icon.webp'
import powerfulCleanIcon from '@/icons/powerful-clean-icon.webp'
import usLabTestedIcon from '@/icons/us-lab-tested-icon.webp'
import { logInfo } from '@/utilities/log'
import register from 'preact-custom-element'
import { render } from 'preact-render-to-string'
import { createPortal } from 'preact/compat'
import ConfettiExplosion from 'react-confetti-explosion'

const questions = [
  {
    title: 'What laundry detergent do you currently use?',
    name: 'What laundry detergent do you currently use?',
    bodyHtml: '(Select your favorite)',
    options: [
      {
        label: 'Tide',
        image: {
          src: 'https://cdn.shopify.com/s/files/1/0665/0196/8109/files/Tide_Liquid.jpg?v=1740584639',
          alt: 'Tide'
        }
      },
      {
        label: 'Gain',
        image: {
          src: 'https://cdn.shopify.com/s/files/1/0665/0196/8109/files/Gain_Aroma_Boost.jpg?v=1740584639',
          alt: 'Gain Aroma Boost'
        }
      },
      {
        label: 'Arm & Hammer',
        image: {
          src: 'https://cdn.shopify.com/s/files/1/0665/0196/8109/files/Arm_Hammer_Clean_Burst.jpg?v=1740584639',
          alt: 'Arm & Hammer Clean Burst'
        }
      },
      {
        label: 'All',
        image: {
          src: 'https://cdn.shopify.com/s/files/1/0665/0196/8109/files/All_Liquid_Detergent.jpg?v=1740611037',
          alt: 'All'
        }
      },
      {
        label: 'Persil',
        image: {
          src: 'https://cdn.shopify.com/s/files/1/0665/0196/8109/files/71TEK29523L._AC_SL1500.jpg?v=1740611110',
          alt: 'Persil'
        }
      },
      {
        label: 'Seventh Generation',
        image: {
          src: 'https://cdn.shopify.com/s/files/1/0665/0196/8109/files/Seventh_Generation.jpg?v=1740755110',
          alt: 'Seventh Generation'
        }
      },
      { label: 'Other' }
    ]
  },
  {
    title: '',
    name: 'Have you ever wondered',
    bodyHtml: render(
      <div>
        <p>
          🤔 <em>Have you ever wondered...</em>
        </p>
        <h4>What&#39;s REALLY in Your laundry detergent?</h4>
        <br></br>
        <p>Many popular detergents are packed with...</p>
        <br></br>
        <p>
          <h6 style='color:#D8273D;'>
            <span>🧪 </span>
            optical brighteners
          </h6>
          <h6 style='color:#D8273D;'>
            <span>😱 </span>
            hormone disrupting phthalates
          </h6>
          <h6 style='color:#D8273D;'>
            <span>💩 </span>
            and carcinogenic 1,4 Dioxane
          </h6>
        </p>
        <br></br>
        <p>...that could irritate your skin, or worse...</p>
        <br></br>
        <h6>But don&#39;t worry! We have a solution.</h6>
        <em>Hit next to see if it&#39;s right for you...</em>
      </div>
    ),
    options: []
  },
  {
    title: `Would you swap your favorite detergent for a safer alternative that gives you the same powerful clean you're used to?`,
    name: 'Would you swap',
    bodyHtml: '',
    options: [
      { label: '✅ YES!' },
      { label: '‼️ No, I love my unhealthy habits' },
      { label: "🤔 I'm not sure" }
    ]
  },
  {
    title: `Your current detergent is too inconvenient. Are you ready to save $100s every year and get it shipped to your doorstep via free shipping?`,
    name: 'Are you ready to save',
    bodyHtml: '',
    options: [
      { label: '✅ YES!' },
      { label: '‼️ No, I like inconvenient and expensive detergents' },
      { label: "🤔 I'm not sure" }
    ]
  },
  {
    title: `You're wasting too much time when doing laundry. Are you ready to skip the measuring, pouring, mess, and free up more space in your laundry room than ever?`,
    name: 'Are you ready to skip',
    bodyHtml: '',
    options: [
      { label: '✅ YES!' },
      { label: '‼️ No, I love wasting time and making a mess' },
      { label: "🤔 I'm not sure" }
    ]
  }
]

const completeFeaturedImage = {
  src: 'https://cdn.shopify.com/s/files/1/0665/0196/8109/files/Quiz_Complete_Made_in_the_US_image.png?v=1754927322',
  alt: 'Earth Breeze Laundry Detergent Sheets'
}

// Register the <x-quiz> custom element with default props
register(
  () => (
    <Quiz
      questions={questions}
      skipLinkLabel='Skip quiz and get 64% off* harsh-chemical-free detergent'
      skipLinkUrl='/gwp'
      completePage={
        <QuizComplete
          featuredImage={completeFeaturedImage}
          ctaButtonLabel='Claim 64% OFF* With 4 FREE Gifts'
          ctaButtonUrl='/gwp'
        />
      }
    />
  ),
  'x-quiz'
)

export type QuizCompleteProps = {
  ctaButtonLabel?: string
  ctaButtonUrl?: string
  featuredImage?: {
    src: string
    alt?: string | null
  }
}

export default function QuizComplete({
  ctaButtonLabel = 'Get My Discount',
  ctaButtonUrl = '/gwp',
  featuredImage
}: QuizCompleteProps): JSX.Element {
  return (
    <div>
      <div className='mb-32 flex flex-col items-center gap-y-2 px-5vw pb-2 sm:gap-y-3 md:m-0'>
        <div className='rounded-xl bg-deep-ocean-blue p-2 text-xs font-medium leading-none text-crisp-white sm:text-sm'>
          You Unlocked Our Special Offer!
        </div>
        <h6 className='leading-tight md:text-3xl'>You get 64% OFF* With 4 FREE Gifts!</h6>
        <p className='text-sm leading-tight md:text-base'>
          Instantly make your laundry routine{' '}
          <span className='font-bold'>free of harsh chemicals</span> With{' '}
          <span className='font-bold'>the same powerful clean</span> you&#39;re used to!
        </p>
        {featuredImage && (
          <div className='relative h-[25dvh] overflow-hidden  rounded lg:h-[28dvh]'>
            <img
              src={featuredImage.src}
              alt={featuredImage.alt ?? 'Eco-Friendly Detergent'}
              // eslint-disable-next-line tailwindcss/enforces-shorthand
              className='h-full w-full object-contain'
            />
          </div>
        )}
        <div className='grid max-w-110 grid-cols-4 gap-2'>
          <img src={usLabTestedIcon} alt='US Lab Tested' />
          <img src={easilyDissolvesIcon} alt='Easily Dissolves' />
          <img src={noHarshChemicalsIcon} alt='No Harsh Chemicals' />
          <img src={powerfulCleanIcon} alt='Powerful Clean' />
        </div>
        <div className='card max-w-192 border border-deep-ocean-blue/[.12] bg-[#fff5e3] md:p-8'>
          {' '}
          <p>
            <span className='font-bold uppercase text-error-red'>LIMITED TIME:</span> Make the
            switch to safer, and better for the planet detergent{' '}
            <span className='font-bold'>at an internet-only price.</span>
          </p>
          <p className='font-bold'>Up to 64% OFF* With 4 FREE Gifts for new subscribers!</p>
        </div>
      </div>
      <div className='fixed bottom-0 mx-auto flex w-full flex-col gap-y-2 bg-cloud-white p-3 lg:static lg:w-max lg:bg-transparent'>
        <a href={ctaButtonUrl} onClick={() => logInfo('QuizResultCtaClicked')}>
          <button className='btn btn-square btn-fresh-scent w-full md:w-auto lg:px-20'>
            {ctaButtonLabel}
            <span className='ml-2 inline-block h-4 w-6'>
              <img src={nextArrowIcon} alt='Next Arrow' height={16} width={16} />
            </span>
          </button>
        </a>
        <span className='text-xs font-semibold text-fresh-scent'>
          <img src={checkIcon} alt='Check' className='mr-1 inline-block align-top' height={12} />
          VERIFIED LOWEST PRICE EVER
        </span>
      </div>
      {createPortal(
        <div className='absolute left-1/2 top-0 -translate-x-1/2'>
          <ConfettiExplosion particleCount={200} particleSize={8} />
        </div>,
        document.body
      )}
    </div>
  )
}
